/* eslint no-undef: "off" */

class GoogleV3Hide {
  #env =
    globalThis?.import_meta_env?.VITE_RECAPTCHA_V3_HIDE ||
    process.env.VITE_RECAPTCHA_V3_HIDE ||
    import.meta.env.VITE_RECAPTCHA_V3_HIDE;
  #recaptcha;
  #captchaUrl = "https://www.google.com/recaptcha/api.js";
  loadCallbackFnName = "v3Load";
  errorCallbackFnName = "V3Error";
  constructor() {
    const isCanInitCaptcha =
      this.#env &&
      this.#captchaUrl &&
      this.loadCallbackFnName &&
      this.errorCallbackFnName;

    if (isCanInitCaptcha) {
      this.#init();
    } else {
      console.error(
        "GoogleV3Hide - captcha is not init, VITE_RECAPTCHA_V3_HIDE is not defined",
      );
    }
  }

  #init() {
    console.log("init");
    const isCaptchaLoad = this.checkLoad();

    if (!isCaptchaLoad) {
      console.log("isCaptchaLoad");
      window[this.loadCallbackFnName] = this.v3Load.bind(this);
      window[this.errorCallbackFnName] = this.V3Error.bind(this);
      const scriptElement = document.createElement("script");
      const scriptSource = new URL(this.#captchaUrl);
      scriptSource.search = new URLSearchParams({
        onload: this.loadCallbackFnName,
        render: this.#env,
        onerror: this.errorCallbackFnName,
      }).toString();
      scriptElement.src = scriptSource.toString();
      scriptElement.async = true;
      document.head.appendChild(scriptElement);
    }
  }

  V3Error(e) {
    console.log("V3Error");
    console.error("GoogleV3Hide - captcha is not init", e);
  }

  v3Load() {
    console.log("v3Load");
    this.#recaptcha = window?.grecaptcha;

    const captchaNode = document.querySelector(".grecaptcha-badge");

    if (captchaNode) {
      captchaNode.style.display = "none";
    }
  }

  checkLoad() {
    console.log("checkLoad");

    return this.#recaptcha;
  }

  check() {
    console.log("check");

    return new Promise((resolve) => {
      this.#recaptcha.ready(() => {
        this.#recaptcha
          .execute(this.#env, { action: "submit" })
          .then((token) => {
            if (token) {
              resolve(token);
            }
          });
      });
    });
  }
}

const CaptchaV3HideService = new GoogleV3Hide();

export default CaptchaV3HideService;
